// Couleurs partagées pour les composants demandeur
export const colors = {
  primary: '#FF6B00',
  primaryLight: '#FFF0E6',
  primaryDark: '#D95A00',
  secondary: '#437011',
  secondaryLight: '#F4F8E9',
  secondaryDark: '#365D0E',
};

// Animation fadeIn
export const globalStyles = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .animate-fadeIn {
    animation: fadeIn 0.3s ease-in-out;
  }
`;
